/**
 * SunoCoverPickerSheet — шторка выбора одной обложки из двух вариантов.
 *
 * Открывается автоматически когда `SunoCoverJobsContext.pendingChoice`
 * заполнен (после завершения cover-job'а). Юзер видит 2 превью, жмёт
 * на нужную → `applyChoice` обновляет `suno_tracks.image_url` и закрывает
 * шторку. Крестик отменяет выбор (URL'ы теряются, старая обложка остаётся).
 */
import { useState } from 'react'
import Sheet from '../../../components/Sheet'
import { useSunoCoverJobs } from '../../../context/SunoCoverJobsContext'

export default function SunoCoverPickerSheet() {
	const { pendingChoice, dismissChoice, applyChoice } = useSunoCoverJobs()
	const [applying, setApplying] = useState<string | null>(null)

	if (!pendingChoice) return null

	const handlePick = async (url: string) => {
		if (applying) return
		setApplying(url)
		try {
			await applyChoice(pendingChoice.trackId, url)
		} finally {
			setApplying(null)
		}
	}

	return (
		<Sheet
			open={!!pendingChoice}
			onClose={dismissChoice}
			variant="center"
			title="Выбери обложку"
			className="suno-cover-picker"
		>
			<div className="suno-cover-picker__body">
				<div className="suno-cover-picker__track">
					{pendingChoice.title?.trim() || 'Без названия'}
				</div>
				<p className="suno-cover-picker__hint">
					Suno сгенерировал {pendingChoice.imageUrls.length} вариант
					{pendingChoice.imageUrls.length === 1 ? '' : 'а'}. Нажми на тот
					который хочешь применить к треку.
				</p>

				<div className="suno-cover-picker__grid">
					{pendingChoice.imageUrls.map((url, i) => {
						const isLoading = applying === url
						return (
							<button
								key={url}
								type="button"
								className={`suno-cover-picker__item${isLoading ? ' suno-cover-picker__item--loading' : ''}`}
								onClick={() => handlePick(url)}
								disabled={!!applying}
								title="Применить как обложку трека"
							>
								<img
									src={url}
									alt={`Вариант ${i + 1}`}
									className="suno-cover-picker__img"
									loading="lazy"
								/>
								<span className="suno-cover-picker__label">Вариант {i + 1}</span>
								{isLoading && (
									<span className="suno-cover-picker__spinner" aria-hidden="true" />
								)}
							</button>
						)
					})}
				</div>
			</div>
		</Sheet>
	)
}
